<template>
  <v-container>
    <SecretsProgressLinear></SecretsProgressLinear>
    <v-spacer></v-spacer>
    <GenericChecklist @increment="increment" @decrement="decrement" :headers="[{text:'completed', value:'completed'},{text:'area', value:'area_id'}]" :items="filtered" :itemKey="'area_id'"></GenericChecklist>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import GenericChecklist from '@/components/GenericChecklist'
import SecretsProgressLinear from "@/components/SecretsProgressLinear";


export default {
  name: "Secrets",
  components: { SecretsProgressLinear, GenericChecklist },
  computed: {
    ...mapGetters("entities/secrets",["filtered"])
  },
  methods: {
    ...mapActions("entities/secrets", ["increment", "decrement"]),
  },
};
</script>
